<template>
  <div class="content-wrapper questionnare-wrapper questionnare-question-3">
    <div class="d-flex align-items-start justify-content-center full-height">
      <div class="center full-width">
        <div class="small-text uppercase">Question 2 of 5</div>
        <h3 class="my-4 general-title">Who are you?</h3>
        <div class="question-container my-9 d-flex">
            <button
            class="btn btn-outline-primary questionnaire-prev"
            type="button"
            value="Previous question"
            v-on:click="$emit('go-back')"
          >
            Previous question
            </button>
          <input class="center" type="text" name="birthdate" placeholder="YEAR OF BIRTH" v-model="inputBirthdate" />
          <select class="center" name="weight" placeholder="WEIGHT (KG)" v-model="inputWeight">
              <option selected disabled>WEIGHT (KG)</option>
              <option value="50-60">50 - 60 KG</option>
              <option value="60-70">60 - 70 KG</option>
              <option value="70-80">70 - 80 KG</option>
              <option value="80+">MORE THAN 80KG</option>
              <option value="none">I'DE RATHER NOT SAY</option>
          </select>
          <input class="center" type="text" name="liveplace" placeholder="WHERE DO YOU LIVE?" v-model="inputLiveplace" />
          <button
            class="btn btn-outline-primary questionnaire-next"
            type="button"
            value="Next question"
            v-on:click="localGoNext"
          >
          Next question
          </button>
        </div>
      </div>
      <a v-on:click="$emit('skip-questionnaire')" class="skip-button small-text uppercase" href="#">skip questionnaire</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "questionnare-question-3",
  data() {
    return {
    };
  },
  props: ['questionAnswers'],
  methods: {
    localGoNext: function() {
      if (this.canGoNext()) {
        this.$emit('go-next');
      }
    },
    canGoNext: function() {
      let err = false;
      let firstFocus = false;
      let requiredField = ['birthdate', 'liveplace', 'weight'];

      for (let i = 0; i < requiredField.length; i++) {
        let fieldName = requiredField[i];
        let k = this.questionAnswers[fieldName];
        if (typeof k == "undefined" || k == "") {
          if (!firstFocus && document.querySelector("[name=" + fieldName + "]")!=null) {
            document.querySelector("[name=" + fieldName + "]").focus();
          }
          err = true;
          firstFocus = true;
        }
      }
      return !err;
    }
  },
  mounted() { 
      document.querySelector('select option:first-child').removeAttribute('selected');
      document.querySelector('select option:first-child').setAttribute('selected', 'selected');
  },
  computed: {
    inputBirthdate: {
      get() {
        return this.questionAnswers.birthdate;
      },
      set(answer) {
        this.$emit('set-answer', answer, 'birthdate');
      }
    },
    inputWeight: {
      get() {
        return this.questionAnswers.weight;
      },
      set(answer) {
        this.$emit('set-answer', answer, 'weight');
      }
    },
    inputLiveplace: {
      get() {
        return this.questionAnswers.liveplace;
      },
      set(answer) {
        this.$emit('set-answer', answer, 'liveplace');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.questionnare-question-3 {
    input[type=text],
    input[type=date],
    select {
        width: 33%;
        @media (max-width: 767px) {
          width: 100%;
          height: 50px;
          margin-right: 0;
        }
    }
    input[type=date] {
      @media (max-width: 767px) {
        padding-left: 30px;
      }
    }
    .questionnaire-next,
    .questionnaire-prev {
      width: 300px !important;
      padding: 0;
    }
}
</style>